import React from 'react';
import style from './TaggedUser.module.scss';

const TaggedUser = ({ displayName }) => {
  return <span className={style.TaggedUser}>@{displayName}</span>;
};

export default TaggedUser;
